import React from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Tooltip
} from '@mui/material';
import {
    Brightness4 as Brightness4Icon,
    Brightness5 as Brightness5Icon,
    Brightness6 as Brightness6Icon,
    Palette as PaletteIcon
} from '@mui/icons-material';
import { useThemeContext } from '../contexts/ThemeContext';

function ThemeToggle() {
    const { themeMode, toggleTheme } = useThemeContext();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleThemeChange = (mode) => {
        toggleTheme(mode);
        handleClose();
    };

    const getIcon = () => {
        switch (themeMode) {
            case 'medium':
                return <Brightness6Icon />;
            case 'dark':
                return <Brightness4Icon />;
            default:
                return <Brightness5Icon />;
        }
    };

    return (
        <>
            <Tooltip title="Alterar tema">
                <IconButton
                    onClick={handleClick}
                    color="inherit"
                    size="small"
                >
                    {getIcon()}
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem 
                    onClick={() => handleThemeChange('light')}
                    selected={themeMode === 'light'}
                >
                    <ListItemIcon>
                        <Brightness5Icon />
                    </ListItemIcon>
                    <ListItemText>Claro</ListItemText>
                </MenuItem>
                <MenuItem 
                    onClick={() => handleThemeChange('medium')}
                    selected={themeMode === 'medium'}
                >
                    <ListItemIcon>
                        <Brightness6Icon />
                    </ListItemIcon>
                    <ListItemText>Meio Escuro</ListItemText>
                </MenuItem>
                <MenuItem 
                    onClick={() => handleThemeChange('dark')}
                    selected={themeMode === 'dark'}
                >
                    <ListItemIcon>
                        <Brightness4Icon />
                    </ListItemIcon>
                    <ListItemText>Escuro</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}

export default ThemeToggle;

